export const EMBED_AUTH_REQUEST = "open-ga:auth-request"; // 嵌入式iframe请求认证事件
export const EMBED_AUTH_RESPONSE = "open-ga:auth-response"; // 嵌入式iframe响应认证事件
export const EMBED_AUTH_INVALID = "open-ga:auth-invalid"; // 嵌入式iframe认证无效事件
export const EMBED_AUTH_ERROR = "open-ga:auth-error"; // 嵌入式iframe认证错误事件
export const EMBED_AUTH_LOGOUT = "open-ga:auth-logout"; // 嵌入式iframe认证登出事件
export const EMBED_AUTH_SESSION_VALID = "open-ga:auth-session-valid"; // 嵌入式iframe认证会话有效事件
export const EMBED_AUTH_REFRESHED = "open-ga:auth-refreshed"; // iframe 刷新令牌后同步至主页面
export const HOST_AUTH_LOGOUT_EVENT = "oga:auth-logout"; // 主页面认证登出事件

// 主页面认证登出事件
export const announceOpenGaLogout = () => {
  window.dispatchEvent(new Event(HOST_AUTH_LOGOUT_EVENT));
};

// 创建只在父子页面内存中传递的凭证对象；账号密码不会写入 localStorage。
export const createOpenGaCredentials = (accountCredentials) => {
  const username = accountCredentials?.username?.trim();
  const password = accountCredentials?.password;
  if (!username || !password) {
    throw new Error("获取 OGE 账户凭证失败：响应中缺少账号或密码");
  }

  return {
    username,
    password,
    ogaToken: localStorage.getItem("token") || "",
    ogaRefreshToken: localStorage.getItem("refreshToken") || "",
  };
};
